import { Model } from '@appstrax/services/database';

export type MarketplaceBidStatus = 'Pending' | 'Accepted' | 'Declined' | 'Withdrawn';

export class MarketplaceBid extends Model {
  public listingId: string = '';
  public bidderId: string = '';
  public amount: number = 0;
  public message?: string;
  public status: MarketplaceBidStatus = 'Pending';
}

